import { AUTH } from "constants/types";
import { api, authApi, formData } from "utils";
import Cookies from "universal-cookie";

const cookies = new Cookies();


export const register = (obj) => () =>
	api.post('/register', formData(obj))
		.then(res => {
			return res
		})
		.catch(err => {
			throw err
		});


export const registerWithGoogle = (data) => () =>
	api.post('/oauth/google', formData(data))
		.then(res => {
			return res
		})
		.catch(err => {
			throw err
		})


export const requestMagicLink = (data) => () =>
	api.post('/login/magic/request', formData(data))
		.then(res => {
			return res
		})
		.catch(err => {
			throw err
		})

export const confirmMagicLogin = (data) => () =>
	api.post('/login/magic', formData(data))
		.then(res => {
			return res
		})
		.catch(err => {
			throw err
		})


export const loginWithGoogle = (data) => (dispatch) =>
	api.post('/oauth/google', formData(data))
		.then((res) => {
			if (res.status === 200) {
				dispatch({
					type: AUTH.SIGNED_IN
				});
				return res
			} else if (res && res.status === 202) {
				return res
			} else {
				throw res
			}
		})
		.catch(err => {
			throw err
		})

export const getSelfUser = () => (dispatch) => {
	return authApi.get('/self').then(res => {
		if (!res.error) {

			dispatch({
				type: AUTH.SIGNED_IN,
				payload: {
					user: (res.data || {}).user || {},
					shop: (res.data || {}).shop || {}
				}
			});

			return res
		} else {
			throw res
		}
	}).catch(err => {
		throw err
	})
}

export const getUserNotifications = () => (dispatch) => {
	return authApi.get('/self').then(res => {
		if (!res.error) {
			dispatch({
				type: AUTH.USER_NOTIFICATIONS,
				payload: {data: res.data.notifications}
			})
			return res
		}
	}).catch(err => {
		throw err
	})
}

export const markAsRead = () => (dispatch) =>
	authApi.post(`/notifications/read`)
		.then(res => {
			if (!res.error) {
				dispatch({
					type: AUTH.MARK_AS_READ,
				})
			} else {
				throw new Error('Auth Failed')
			}
		})
		.catch(err => {
			throw err
		})

export const getShops = () => (dispatch) => {

	return authApi.get(`/self/shops`)
		.then(res => {
			if (res.status === 200) {
				dispatch({
					type: AUTH.USER_SHOPS,
					payload: res,
				})
				return res
			} else {
				throw res
			}
		}).catch(err => {
			throw err
		})
}

export const getCurrentSession = () => () => {

	return authApi.get(`/self`)
		.then(res => {
			if (res.status === 200) {
				return res
			} else {
				throw res
			}
		})
		.catch(err => {
			throw err
		})
}

export const changeShops = (shop_id, route) => (dispatch) =>
	authApi.post(`/shops/auth`, formData({shop_id}))
		.then(res => {
			if (res.status === 200) {

				cookies.set('accessToken', res.data.token, {
					domain: "local-test-paylixecommerce.com",
					path: "/",
				});
				cookies.set('accessToken', res.data.token, {
					domain: "paylix.gg",
					path: "/",
				});
				cookies.set('accessToken', res.data.token, {
					domain: "paylix.gg",
					path: "/",
				});
				cookies.set('accessToken', res.data.token, {
					domain: "paylixecommerce-staging.io",
					path: "/",
				});
				cookies.set('accessToken', res.data.token, {
					domain: "paylixecommerce-crispy.io",
					path: "/",
				});

				authApi.interceptors.request.use(
					config => {
						if (!config.withoutAuth) {
							config.headers.Authorization = `Bearer ${res.data.token}`
						}

						return config
					},
					error => Promise.reject(error.response),
				)

				return dispatch(getSelfUser())
			} else {
				throw res
			}
		})
		.then(() => {
			if (route) {
				window.location.href = route;
			} else {
				window.location.pathname = `/`
			}
		})
		.catch(err => {
			throw err
		})


export const logIn = (values) => (dispatch) => {
	return api.post('/login', formData(values))
		.then(res => {

			if (res && res.status === 200) {
				dispatch({
					type: AUTH.SIGNED_IN
				});
				return res
			} else if (res && res.status === 202) {
				return res
			} else {
				throw res
			}

		})
		.catch(err => {
			throw err
		})
}

export const emailAuthentication = (obj) => (dispatch) =>
	authApi.post('/auth/2fa/email', formData(obj))
		.then(res => {
			if (res && res.status === 200) {
				dispatch({type: AUTH.SIGNED_IN})
				return res
			} else if (res && res.status === 202) {
				return res
			} else {
				throw res
			}
		})
		.catch(err => {
			throw err
		});


export const OTPAuthentication = (obj) => (dispatch) =>
	authApi.post('/auth/2fa/otp', formData(obj))
		.then(res => {
		if (res && res.status === 200) {
			dispatch({type: AUTH.SIGNED_IN})
			return res
		} else throw res
	})
		.catch(err => {
			throw err
		});


export const resendValidate = (email) => () =>
	api.post('/validate/resend', formData(email))
		.then(res => res)
		.catch(err => {
			throw err
		});


export const resendEmailValidate = (email) => () =>
	authApi.post('/auth/2fa/email/resend', formData(email))
		.then(res => res)
		.catch(err => {
			throw err
		})


export const requestNewPassword = (obj) => () =>
	api.post('/reset/request', formData(obj))
		.then(res => {
			if (res && res.status === 200) {
				return res
			} else throw res
		}).catch(err => {
		throw err
	})


export const resetPassword = (obj) => () =>
	api.post('/reset/password', formData(obj))
		.then(res => {
			if (res && res.status === 200) {
				return res
			} else throw res
		})
		.catch(err => {
			throw err
		})


export const getUserSettings = () => (dispatch) =>
	authApi.get('/self/settings')
		.then(res => {
			if (res && res.status === 200) {
				dispatch({
					type: AUTH.USER_SETTINGS,
					payload: res.data.settings
				})
				return res
			} else throw res
		})
		.catch(err => {
			throw err
		})


export const signOut = () => (dispatch) =>
	authApi.post('/logout')
		.then(res => {
			if (res && res.status === 200) {
				dispatch({
					type: AUTH.SIGNED_OUT
				});
				return true;
			} else {
				throw res
			}
		})
		.catch(err => {
			throw err
		});


export const resetOTP = (data) => () =>
	authApi.post('/reset/otp', formData(data))
		.then(res => {
			if (res && res.status === 200) {
				return res
			} else if (res && res.status === 202) {
				return res
			} else throw res
		})
		.catch(err => {
			throw err
		})